import { throwErrorMessage } from 'dashboard/store/utils/api';
import ConversationApi from '../../../../api/inbox/conversation';
import mutationTypes from '../../../mutation-types';

// Coalesce update_last_seen calls per conversation. markMessagesRead is
// triggered on every incoming message, conversation update, scroll-to-message
// and socket reconnect (syncActiveConversationMessages). Without a debounce a
// rapid message stream fires one HTTP request per message. 5s is well below the
// time a human spends reading, so the unread badge stays accurate in practice.
const READ_DEBOUNCE_MS = 5000;
const lastReadSentAtByConversation = {};

// A conversation that hasn't been read in this long won't need its debounce
// entry again (the badge is re-synced from the server on the next visit), so
// drop it to bound the map's size in long-lived dashboard sessions.
const STALE_ENTRY_MS = 10 * 60 * 1000;
let lastPrunedAt = 0;

function pruneStaleReadEntries(now) {
  Object.keys(lastReadSentAtByConversation).forEach(conversationId => {
    if (now - lastReadSentAtByConversation[conversationId] > STALE_ENTRY_MS) {
      delete lastReadSentAtByConversation[conversationId];
    }
  });
}

export default {
  markMessagesRead: async ({ commit }, { id }) => {
    const now = Date.now();
    if (now - (lastReadSentAtByConversation[id] || 0) < READ_DEBOUNCE_MS) {
      return;
    }
    lastReadSentAtByConversation[id] = now;

    // Prune stale entries at most once per prune window to keep the map small
    // without adding work to every mark-as-read call.
    if (now - lastPrunedAt > STALE_ENTRY_MS) {
      lastPrunedAt = now;
      pruneStaleReadEntries(now);
    }

    try {
      const {
        data: { id: conversationId, agent_last_seen_at: lastSeen },
      } = await ConversationApi.markMessageRead({ id });
      setTimeout(
        () =>
          commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
            id: conversationId,
            lastSeen,
          }),
        4000
      );
    } catch (error) {
      // Handle error
    }
  },

  markMessagesUnread: async ({ commit }, { id }) => {
    try {
      const {
        data: { agent_last_seen_at: lastSeen, unread_count: unreadCount },
      } = await ConversationApi.markMessagesUnread({ id });
      commit(mutationTypes.UPDATE_MESSAGE_UNREAD_COUNT, {
        id,
        lastSeen,
        unreadCount,
      });
    } catch (error) {
      throwErrorMessage(error);
    }
  },
};
